<template>
  <div class="container">
    <div class="top">
      <!--<img class="img " src="@/assets/image/banner.png" alt="">-->
      <el-carousel :interval="5000" arrow="always" class="pcbanner">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <div class="bannerbox">
            <img :src="item.picUrl" alt="">
          </div>
        </el-carousel-item>
      </el-carousel>
      <el-carousel :interval="5000" arrow="always" class="m-banner">
        <el-carousel-item v-for="item in bannerList2" :key="item.id">
          <img :src="item.picUrl" alt="">
        </el-carousel-item>
      </el-carousel>
      <div class="topbox">
        <div class="left">
          <div class="left_top">
            <div class="dw"></div> <div class="cs">{{areaName}}</div><div class="qhbtn">
            <el-dropdown placement="bottom" @command="areaTab">
            <span class="el-dropdown-link">切换 <i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item) in areaList" :command="item" :key="item.id">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
            </el-dropdown>
          </div>
          </div>
          <div class="left_inputs">
            <el-form ref="form" :model="form" :rules="rules">
              <el-form-item label="" prop="hospitalId">
                <el-select v-model="form.hospitalId" filterable placeholder="请选择医院" @change="hopChange">
                  <el-option
                    v-for="item in list3"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  style="width: 100%">
                  </el-option>
                </el-select>
                <!--<el-autocomplete-->
                  <!--porp=""-->
                  <!--style="width: 100%;"-->
                  <!--class="inline-input"-->
                  <!--v-model="form.department"-->
                  <!--:fetch-suggestions="querySearch"-->
                  <!--placeholder="请输入检测部位"-->
                  <!--:trigger-on-focus="false"-->
                  <!--@select="handleSelect"-->
                <!--&gt;</el-autocomplete>-->
              </el-form-item>
              <el-form-item label="" prop="departmentId">
                <el-select v-model="form.departmentId" filterable placeholder="请选择科室" @change="ksChange">
                  <el-option
                    v-for="item in deparList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.id"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <!--<el-form-item label="" prop="area">-->
                <!--<el-input placeholder="请输入地区" v-model="form.area"></el-input>-->
              <!--</el-form-item>-->
              <el-form-item label="" prop="appointmentTime">
                <el-date-picker
                  style="width: 100%"
                  v-model="form.appointmentTime"
                  type="date"
                  placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="" prop="name">
                <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="" prop="phone">
                <el-input placeholder="请输入手机号" v-model="form.phone"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="text-align: center;"><el-button class="btn" @click="submit">PETCT/MR快速预约</el-button></div>
          <img class="zhitong" src="@/assets/image/zt.png" alt="">
        </div>
        <!--<div class="conter">-->
          <!--<div class="conter_top">-->
            <!--<el-carousel height="289px">-->
              <!--<el-carousel-item v-for="item in bannerList" :key="item.id">-->
                <!--<div class="lbbox">-->
                  <!--&lt;!&ndash;<p class="p1">认识PET-CT检查</p>&ndash;&gt;-->
                  <!--&lt;!&ndash;<p class="p2">PET-CT是最高档PET扫描仪和先进螺旋CT设备功能的一体化完&ndash;&gt;-->
                  <!--&lt;!&ndash;美融合，临床主要应用于肿瘤、脑和心脏等领域重大疾病的早期&ndash;&gt;-->
                  <!--&lt;!&ndash;发现和诊断。</p>&ndash;&gt;-->
                  <!--<img :src="item.picUrl" alt="">-->
                <!--</div>-->
              <!--</el-carousel-item>-->
            <!--</el-carousel>-->
          <!--</div>-->
          <!--<div class="conter_foot">-->
            <!--<div class="fot_left">-->
              <!--<div class="l_top"><i class="el-icon-menu" style="color: #CB0E07; font-size: 16px"></i> <span>预约科室</span></div>-->
              <!--<div class="l_bot">-->
                <!--<div class="l">-->
                  <!--<span :class="active == 'all' ? 'active': ''" @click="depatTab('all', null)">不限</span>-->
                <!--</div>-->
                <!--<div class="r">-->
                  <!--<span v-for="(item, index) in deparList" :key="item.id" @click="depatTab(index, item.id)" :class="active == index ? 'active': ''">{{item.name}}</span>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="fot_left" style="margin-left: 8px;">-->
              <!--<div class="l_top"><i class="el-icon-menu" style="color: #CB0E07; font-size: 16px"></i> <span>预约地区</span></div>-->
              <!--<div class="l_bot">-->
                <!--<div class="l">-->
                  <!--<span :class="active2 == 'all' ? 'active': ''" @click="areaTab('all', null)">全国</span>-->
                <!--</div>-->
                <!--<div class="r">-->
                  <!--<span v-for="(item, index) in areaList" :key="item.id" @click="areaTab(index, item.id)" :class="active2 == index ? 'active': ''">{{item.name}}</span>-->
                <!--</div>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
        <div class="right">
          <div class="r-top">
            <h2 title="">热门文章</h2>
            <ul class="wzbox">
              <template v-for="(item, index) in newList">
                <li v-if="index == 0" class="top"  :key="item.id" @click="zxinfo(item.id)">
                  <img class="imgtop" :src="item.picUrl" alt="">
                  <h5>{{item.name}}</h5>
                  <p>{{item.createTime}}</p>
                </li>
                <li v-if="index !== 0" class="item" :key="item.id" @click="zxinfo(item.id)">
                  <div class="imgbox">
                    <img :src="item.picUrl" alt="">
                  </div>
                  <div class="xxbox">
                    <h5>{{item.name}}</h5>
                    <p>{{item.createTime}}</p>
                  </div>
                </li>
              </template>
            </ul>
            <!--<el-tabs v-model="activeName" @tab-click="handleClick">-->
              <!--<el-tab-pane label="公告" name="gonggao">-->
                <!--<ul>-->
                  <!--<li v-for="item in newList" :key="item.id" @click="zxinfo(item.id)">{{item.name}}</li>-->
                <!--</ul>-->
              <!--</el-tab-pane>-->
              <!--<el-tab-pane label="新闻" name="news"><ul>-->
                <!--<li v-for="item in newList" :key="item.id" @click="zxinfo(item.id)">{{item.name}}</li>-->
              <!--</ul></el-tab-pane>-->
            <!--</el-tabs>-->
          </div>
          <!--<div class="r-bottom">-->
            <!--<img class="img1" src="@/assets/image/rwm1.png" alt="">-->
            <!--<p>微信扫码预约</p>-->
          <!--</div>-->
        </div>
      </div>
    </div>
    <div class="warp">
      <div class="center">
        <div class="title"><span>推荐医院</span> <span @click="yiyuanList">查看更多</span></div>
        <div class="contentBox">
          <div class="l">
            <img src="../../assets/image/yy.png" alt="">
            <div class="neir">
              <span>不收费</span>
              <span>选择多</span>
              <br/>
              <span>免等待</span>
              <span>服务好</span>
            </div>
          </div>
          <ul class="c">
            <li v-for="(item) in list3" :key="item.id" @click="goinfo(item.id)">
              <div class="imgbox">
                <img :src="item.picUrl" alt="">
              </div>
              <h3>{{item.name}}</h3>
              <p>{{item.introduction}}</p>
              <div>
                <i class="el-icon-user-solid"></i>
                <span>检查价格 ：￥{{item.salesPrice}}</span>
              </div>
            </li>
          </ul>
          <div class="r">
            <p class="tip">HOSPITAL</p>
            <div class="titleDiv">
              <i class="xiao"></i><i class="dao"></i>
              <span>推荐科室</span>
              <i class="dao"></i><i class="xiao"></i>
            </div>
            <ul class="list">
              <li v-for="item in list" :key="item.id" @click="goinfo(item.id)">
                <img :src="item.picUrl" alt="">
                <div>
                  <h3>{{item.name}}</h3>
                  <p>{{item.introduction}} </p>
                  <span class="btn">预约</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="center">
        <div class="title"><span>推荐专家</span></div>
        <div class="contentBox2 contentBox3">
          <el-tabs v-model="activeName3" @tab-click="handleClick3">
            <template v-for="items in deparList">
              <el-tab-pane :label="items.name" :name="items.id" :key="items.id">
                <div class="yybox">
                  <div class="item" @click="zjxq(item.id)" v-for="item in experList" :key="item.id">
                    <div class="imgbox">
                      <img :src="item.picUrl" alt="">
                    </div>

                    <div>
                      <p class="name">
                        <span>{{item.name}}</span>
                        <span>{{item.categoryPresident}}</span>
                      </p>
                      <p class="yyuan">{{item.introduction}}</p>
                      <div class="div">
                        <p>评分 <span>{{item.score}}</span></p>
                        <p>问诊量 <span>{{item.saleNum}}</span></p>
                      </div>
                      <p class="sc">擅长：{{item.sellPoint}}</p>

                    </div>
                  </div>
                  <div class="item item2" @click="more">
                    查看更多医生
                  </div>


                </div>
              </el-tab-pane>
            </template>


          </el-tabs>

        </div>
      </div>
      <div class="center">
        <div class="title"><span>体检预约指南</span></div>
        <div class="contentBox2" style="margin-bottom: 20px;">
          <div class="l">
            <p class="tipP">
              <span>体检指南</span>
            </p>
            <p class="tip2">为您的健康体检做正确指导</p>
            <img src="../../assets/image/682.png" alt="" >
            <ul>
              <li v-for="item in guideList" :key="item.id">
                <span>{{item.name}}</span>
                <span>{{item.time}}</span>
              </li>
            </ul>
          </div>
          <div class="l">
            <p class="tipP">
              <span>医院攻略</span>
              <!--<span class="hg"></span>-->
              <!--<span>体检攻略</span>-->
            </p>
            <p class="tip2">为您的健康体检做正确指导</p>
            <img src="../../assets/image/683.png" alt="">
            <ul>
              <li v-for="item in guideList2" :key="item.id">
                <span>{{item.name}}</span>
                <span>{{item.time}}</span>
              </li>
            </ul>
          </div>
          <div class="r">
            <div class="title">常见问题</div>
            <div class="r_box">
              <template v-for="item in helpList2">
                <div :key="item.id">
                  <div class="t" >{{item.introduction}}</div>
                  <div class="res">{{item.description}}</div>
                </div>
              </template>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import server from '@/service/server.js'
  import { dateformat } from '@/utils/utils.js'
  export default {
    name: 'index',
    data () {
      return {
          input3: '',
        select: '',
        active: 'all',
        active2: 'all',
        activeName3: '101',
        activeName: 'gonggao',
        activeName2: 'neike',
        bannerList: [],
        bannerList2: [],
        areaList: [],
        list3: [],
        deparList: [],
        experList: [],
        guideList: [],
        helpList2: [],
        guideList2: [],
        newList: [],
        list: [],
        form: {
          name: '',
          phone: '',
          departmentId: '',
          departmentName: '',
          area: '',
          areaSubject: null,
          appointmentTime: '',
          hospitalId: '',
          hospitalName: '',
          remark: ''

        },
        rules: {
          hospitalId: [
            { required: true, message: '请选择医院', trigger: 'change' }
          ],
          departmentId: [
            { required: true, message: '请选择科室', trigger: 'change' }
          ],
          // area: [
          //   { required: true, message: '请输入地区', trigger: 'blur' }
          // ],
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' }
          ],
          appointmentTime: [
            { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
          ]
        },
        categoryDepartment: null,
        parentId: null,
        gonggao: 0,
        areaName: '北京',
        webName: ''

      }
    },
    methods: {
      routerClick(path){
        this.$router.push({
          path: path
        })
      },
      querySearch(queryString, cb) {
        var restaurants = this.deparList;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },
      hopChange(e) {
        this.list3.map((item) => {
          if (item.id == e) {
            this.form.hospitalName = item.name
          }
        })
        console.log(e)
      },
      ksChange(e) {
        this.deparList.map((item) => {
          if (item.id == e) {
            this.form.departmentName = item.name
          }
        })
        console.log(e)
      },
      handleSelect(item) {
        console.log(item);
      },
      handleClick2() {

      },
      handleClick(e) {
        console.log(e)
        if (e.name === 'gonggao') {
          this.gonggao = 0
        } else {
          this.gonggao = 1
        }
        this.getNewList()
      },
      handleClick3(e) {
        console.log(e)
        this.getList()
      },
      more() {
        this.$router.push({
          path: '/hospitalList2'
        })
      },
      goinfo(id) {
        this.$router.push({
          path: `/xxjs?id=${id}`
        })
      },
      zxinfo(id) {
        this.$router.push({
          path: `/yyznxq?id=${id}&type=zx`
        })
      },
      hospitalList() {
        server.hospitalList({
          parentId: this.parentId,
          categoryDepartment: this.categoryDepartment
        }).then((res) => {
          this.list3 = res.data
          this.list3.forEach((item) => {
            item.label = item.name
            item.value = item.id
          })
        })
      },
      getList2() {
        server.professional({
          parentId: this.parentId,
          categoryDepartment: this.categoryDepartment
        }).then((res) => {
          this.list = res.data
        })
      },
      depatTab(index, id) {
        this.active = index
        this.categoryDepartment = id
        this.hospitalList()
        this.getList2()
        console.log(index, id)
      },
      areaTab(item) {
        // this.active2 = index
        this.parentId = item.id
        this.areaName = item.name
        this.form.area = item.name
        this.hospitalList()
        this.getList2()
      },
      zjxq(id){
        this.$router.push({
          path: `/zjxq?id=${id}`
        })
      },
      yiyuanList(){
        this.$router.push({
          path: '/hospitalList'
        })
      },
      getList() {
        server.homeExpert({
          parentId: this.activeName3
        }).then((res) => {
          this.experList = res.data
        })
      },
      getNewList() {
        server.informationTj2(0).then((res) => {
          this.newList = res.data
        })
      },
      submit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            server.fastOrder(this.form).then((res) => {
              console.log(res)
              if (res.code === 200) {
                this.$message({
                  message: '快速预约成功',
                  type: 'success'
                });
                this.form = {
                  name: '',
                  phone: '',
                  departmentId: '',
                  departmentName: '',
                  area: '',
                  areaSubject: null,
                  appointmentTime: '',
                  hospitalId: '',
                  hospitalName: '',
                  remark: ''
                }
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error'
                });
              }

            });
          } else {
            return false;
          }
        });
      }
      //
    },
    mounted(){
      server.banner(0).then((res) => {
        this.bannerList = res.data
      })
      server.banner(1).then((res) => {
        this.bannerList2 = res.data
      })
      this.getNewList()
      server.department().then((res) => {
        this.deparList = res.data
        this.deparList.forEach((item) => {
          item.value = item.name
          return item
        })
        this.activeName3 = res.data[0].id
        this.getList()
      })
      server.area().then((res) => {
        this.areaList = res.data
      })
      server.guidePage(2).then((res) => {
        console.log(res.data)
        this.guideList = res.data
        this.guideList.forEach((item) => {
          item.time = dateformat(new Date(item.createTime), 'yyyy-MM-dd')
        })
      })
      server.guidePage(1).then((res) => {
        this.guideList2 = res.data
        this.guideList2.forEach((item) => {
          item.time = dateformat(new Date(item.createTime), 'yyyy-MM-dd')
        })
      })
      server.helpList().then((res) => {
        this.helpList2 = res.data
      })
      this.getList2()
      this.hospitalList()
    }

  }
</script>
<style>
  .el-dropdown-menu {
    width: 300px;
  }
  .el-dropdown-menu li {
    float: left;
  }
</style>
<style lang="scss" scoped>
  .header {
    margin-bottom: 0 !important;
  }
.ep {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.container {
.el-dropdown-link {
  cursor: pointer;
}
  .m-banner {
    display: none;
  }
  .bannerbox {
    background-color: rgb(83, 57, 235);
    img {
      /*width: 1370px;*/
      width: 100%;
      max-width: 1920px;
      height: 600px;
      display: block;
      margin: 0 auto;
    }
  }
  /deep/ .el-carousel__container {
    height: 600px;
  }
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  .warp {
    width: 1370px;
    margin: 0 auto;
  }
  /*background-color: #FFFFFF;*/
  .top {
    /*display: flex;*/
    position: relative;
    .img {
      width: 100%;
      max-width: 1920px;
    }
    .topbox {
      display:flex;
      justify-content: space-between;
      width: 1370px;
      position: absolute;
      top: 50px;
      left: 50%;
      margin-left: -685px;
      z-index: 10;
    }
  }
  /deep/ .el-select {
    width: 100%;
  }
  .left {
    width: 289px;
    height: 492px;
    background-color: #FFFFFF;
    .left_top {
      font-size: 16px;
      /*font-weight: bold;*/
      padding: 20px;
      display: flex;

      /*color: #FFFFFF;*/
      /*background-color: #7ABDFD;*/
      /*height: 46px;*/
      /*line-height: 46px;*/
      .dw {
        width: 14px;
        height: 19px;
        background: url("../../assets/image/dw.png") no-repeat;
      }
      .cs {
        margin: 0 10px;
      }
      .qhbtn {
        color: #635F5F;
        font-size: 14px;
        margin-left: 20px;
        margin-top: 2px;
      }

    }
    .zhitong {
      display: block;
      margin: 30px auto;
    }
    .left_inputs {
      padding: 0px 26px 0 26px;
      /*.el-input {*/
        /*margin-bottom: 13px;*/
      /*}*/
      /*/deep/ .el-input__inner {*/
        /*border: 1px solid #CB0E07 !important;*/
      /*}*/
    }
    /deep/ .btn {
      text-align: center;
      color: #FFFFFF;
      background-color: #CB0E07;
    }
  }
  .conter {
    width: 750px;
    margin: 0 8px;
    .lbbox {
      position: relative;
      color: #2EA7E0;
      p {
        position: absolute;
      }
      .p1 {
        font-size: 32px;
        font-weight: 400;
        left: 32px;
        top: 22px;
      }
      .p2 {
        left: 32px;
        top: 85px;
        width: 540px;
      }
    }
    .conter_foot {
      margin-top: 8px;
      display: flex;
      .fot_left {
        width: 375px;
        height: 195px;
        background-color: #FFFFFF;
        padding-top: 15px;

        .l_top {
          font-size: 18px;
          text-align: center;

          font-weight: 400;
          i {
            vertical-align: middle;
            margin-right: 10px;
          }
        }
        .l_bot{
          margin:30px;
          display: flex;
          .l{
            span{
              font-size: 14px;
              cursor: pointer;
              &.active {
                color: #CB0E07;
              }
            }
          }
          .r{
            width: calc(100% - 35px);
            span{
              color: #6C6969;
              font-size: 14px;
              display: inline-block;
              margin-left: 20px;
              margin-bottom: 5px;
              cursor: pointer;
              &.active {
                color: #CB0E07;
              }
            }
          }
        }
      }
    }
  }
  .right {

    .r-top {
      width: 290px;
      height: 492px;
      font-size: 14px;
      /*color: #666666;*/
      padding: 10px;
      background-color: #FFFFFF;
      h2 {
        border-bottom: 1px solid #DCDFE6;
        font-size: 16px;
        color: #000;
        text-align: center;
        padding-bottom: 10px;
      }
      .wzbox {
        .top {
          .imgtop {
            width: 100%;
            height: 110px;
            display: block;
          }
          h5 {
            font-size: 16px;
            margin: 10px 0;
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          p {
            color: #7A7777;
            border-bottom: 1px solid #DCDFE6;
            padding-bottom: 5px;
          }
        }
        .item {
          display: flex;
          padding: 8px 0;
          cursor: pointer;
          border-bottom: 1px solid #DCDFE6;
          &:last-child {
            border-bottom: none;
          }
          &:hover {
            color: #CB0E07;
          }
          .imgbox {
            width: 78px;
            height: 44px;
            img {
              width: 78px;
              height: 44px;
            }
          }
          .xxbox {
            width: calc(100% - 110px);
            margin-left: 10px;
            p {
              color: #7A7777;
              margin-top: 10px;
            }
          }
          h3 {
            font-size: 14px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
      /deep/ .el-tabs__item.is-active {
        color: #CB0E07;
      }
      /deep/ .el-tabs__active-bar {
        background-color: #CB0E07;
      }
      ul {
        padding: 5px;
      }
      li {

      }
    }
    .r-bottom {
      margin-top: 8px;
      background-color: #FFFFFF;
      width: 312px;
      height: 194px;
      padding: 20px 80px 0 80px;
      font-size: 15px;
      text-align: center;
      color: #A4A4A4;
      .img1 {
        width: 145px;
        height: 145px;
        display: block;
      }
    }
  }
  .center {
    margin-top: 48px;
    .title {
      display: flex;
      margin-bottom: 5px;
      span:nth-child(1){
        font-size: 28px;
        color: #CB0E07;
      }
      span:nth-child(2) {
        font-size: 16px;
        color: black;
        margin-left: auto;
        margin-right: 308px;
        padding-top: 15px;
      }
    }
    .contentBox{
      display: flex;
      .l{
        width: 289px;
        height: 631px;
        position: relative;
        .neir{
          width: 100%;
          height: 100%;
          position: absolute;
          top:0;
          left: 0;
          text-align: center;
          padding-top: 80px;
          span{
            font-size: 15px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
            margin-right: 20px;
          }
        }
      }
      .c{
        display: flex;
        flex-wrap: wrap;
        width: 780px;
        li{
          width: 250px;
          height: 311px;
          background: #FFFFFF;
          margin:0 0 10px 10px;
          cursor: pointer;
          position: relative;
          &:hover {
            box-shadow: 0px 4px 8px #eaeaea;
            ::after {
              width: 100%;
            }

          }
          & ::after {
            content: "";
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 0%;
            height: 3px;
            background-color: #CB0E07;
            transition: all ease 1.2s;
            -webkit-transition: all ease 1.2s;
            -moz-transition: all ease 1.2s;

          }
          .imgbox {
            width: 100%;
            height: 171px;
            overflow: hidden;
          }
          img{
            width: 100%;
            height: 171px;
            transition: all 0.5s;
            &:hover {
             transform: scale(1.1);
            }
          }
          h3{
            font-size: 18px;
            /*font-family: Adobe Heiti Std;*/
            font-weight: bold;
            line-height: 26px;
            height: 52px;
            color: #000000;
            padding: 0 10px;
          }
          p{
            font-size: 13px;
            /*font-family: Adobe Heiti Std;*/
            font-weight: normal;
            color: #9B9B9B;
            padding: 0 10px;
            margin-top: 10px;
          }
          div{
            padding: 0 10px;
            margin-top: 10px;
            span{
              font-size: 13px;
              /*font-family: Adobe Heiti Std;*/
              font-weight: normal;
              color: #CB0E07;
            }
          }
        }
      }
      .r{
        width: 290px;
        height: 630px;
        position: relative;
        background: #fff;
        margin-left: 10px;
        border: 1px solid #f5f5f5;
        .tip{
          font-size: 15px;
          /*font-family: SourceHanSansCN;*/
          font-weight: 400;
          color: #666666;
          text-align: center;
          position: absolute;
          width: 100%;
          top: - 20px;
          left: 0;
        }
        .titleDiv{
          text-align: center;
          padding: 15px 0;
          i{
            display: inline-block;
            margin-left: 5px;
          }
          .xiao{
            width: 10px;
            height: 10px;
            background: #CB0E07;
            border-radius: 50%;
          }
          .dao{
            width: 12px;
            height: 12px;
            background: #CB0E07;
            border-radius: 50%;
          }
          span{
            font-size: 22px;
            /*font-family: Adobe Heiti Std;*/;
            font-weight: normal;
            color: #CB0E07;
            margin:0 50px;
          }
        }
        .list{
          margin-top: 10px;
          li{
            display: flex;
            margin-bottom: 15px;
            height: 97px;
            overflow: hidden;
            img{
              width: 85px;
              height: 97px;
              margin-left: 8px;
            }
            div{
              width: calc(100% - 100px);
              margin-left: 10px;
              padding-right: 10px;
              box-sizing: border-box;
              h3{
                width: 100%;
                overflow:hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 17px;
                line-height: 26px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #323232;
              }
              p{
                /*font-size: 18px;*/
                /*font-family: SourceHanSansCN;*/
                overflow:hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #61C2F0;
                margin: 10px 0;
              }
              .btn{
                width: 84px;
                height: 26px;
                border: 1px solid #CB0E07;
                border-radius: 5px;
                font-size: 16px;
                /*font-family: Adobe Heiti Std;*/;
                font-weight: normal;
                color: #CB0E07;
                text-align: center;
                line-height: 26px;
                cursor: pointer;
                display: inline-block;
              }
            }
          }
        }
      }
    }
    .contentBox2{
      display: flex;
      border: 1px solid #f7f7f7;
      .l{
        margin-right: 10px;
        width: 512px;
        height: 530px;
        padding: 20px;
        box-sizing: border-box;
        background: #fff;
        .tipP{
          span:nth-child(1){
            color: #38A7E4;
            font-size: 18px;
          }
          span:nth-child(2){
            color: #000;
            font-size: 18px;
          }
          .hg {
            height: 10px;
            width: 2px;
            margin: 0 15px;
            background-color: #cccccc;
            display: inline-block;
          }
        }
        .tip2{
          font-size: 18px;
          color: #333;
          margin-top: 40px;
          margin-bottom: 5px;
        }
        ul{
          padding-top: 15px;
          li{
            margin: 10px 0;
            span{
              display: inline-block;
            }
            span:nth-child(1){
              width: 80%;
              padding-right: 20px;
              overflow:hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-size: 14px;
              color: #333;
            }
            span:nth-child(2){
              font-size: 14px;
              width: 20%;
              overflow:hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              text-align: right;
              color: #666;
            }
          }
        }
      }
      .r {
        width: 340px;
        height: 530px;
        background-color: #FFFFFF;
        .title {
          color: #38A7E4;
          padding: 12px 6px;
          border-bottom: 1px solid #CB0E07;
        }
        .r_box {
          padding: 15px;
        }
        .t {
          font-size: 16px;
          color: #515151;
          line-height: 28px;
        }
        .res {
          font-size: 14px;
          line-height: 28px;
          color: #909090;
        }
      }
    }
  }
  ::v-deep .el-tabs__item {
    font-size: 20px;
  }
  .contentBox3 {
    display: block !important;
    .yybox {
      display: flex;
      /*justify-content: space-between;*/
      width: 1370px;
      flex-wrap: wrap;
      .item {
        width: 254px;
        height: 345px;
        border: 1px solid #EEE;
        padding: 20px 10px;
        background: #fff;
        margin: 10px;
        cursor: pointer;
        &.item2 {
          line-height: 315px;
          text-align: center;
          color: rgb(64, 158, 255);
        }
        &:hover {
          img {
            transform: scale(1.2);
          }
        }
        .imgbox {
          width: 133px;
          height: 133px;
          border-radius: 133px;
          overflow: hidden;
          margin: 0 auto 10px;
          img {
            width: 133px;
            height: 133px;
            display: block;
            transition: all 0.5s;
          }
        }

        .btn {
          background: #CB0E07;
          color: #FFFFFF;
          border-radius: 8px 8px 8px 8px;
          display: block;
          float: right;
        }
        p.name{
          text-align: center;
          span:nth-child(1){
            font-size: 16px;
            font-weight: 400;
            color: #347AEE;
          }
          span:nth-child(2){
            color: #000;
            font-size: 16px;
            font-weight: bold;
            margin-left: 5px;
          }
        }
        p.yyuan{
          font-size: 14px;
          color: #666;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          margin: 10px 5px;
        }
        .div{
          display: flex;
          width: 80%;
          margin: 10px auto;
          padding: 10px;
          border-bottom: 1px dashed #666;
          p:nth-child(1){
            font-size: 14px;
            color: #666;
            span{
              font-size: 16px;
              color: #ffb826;
              font-weight: bold;
            }
          }
          p:nth-child(2){
            margin-left: auto;
            font-size: 14px;
            color: #666;
            span{
              font-size: 14px;
              color: #333;
              font-weight: bold;
            }
          }
        }
        p.sc{
          font-size: 14px;
          color: #666;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          margin: 10px 5px;
        }
      }
    }
  }
}
  @media (max-width: 750px) {
    .container .center .contentBox2 .l ul li span:nth-child(2) {
      display: none;
    }
    .container {
      /deep/ .el-tabs__item {
        font-size: 14px;
      }
      /deep/ .el-carousel__container {
        height: 300px;
      }
      .top {
        position: relative;
      }

      .warp {
        padding: 15px;
        width: calc(100% - 20px);
        position: relative;
        top: -80px;
        background-color: #fff;
        border-radius: 10px;
        z-index: 19;
        margin: 0 10px 0 10px;
        box-sizing: border-box;
      }
      .m-banner {
        display: block;
      }
      /deep/ .el-carousel__arrow {
        display: none;
      }
      .pcbanner {
        display: none;
      }
      .center {
        margin-top: 0px;
        .title {
          span {
            font-size: 20px !important;
            &:nth-child(2) {
              font-size: 14px !important;
              color: #cccccc;
              margin-right: 0;
            }
          }

        }
        .contentBox {
          .l {
            display: none;
          }
          .r {
            display: none;
          }
          .c {
            display: flex;
            width: 100%;
            justify-content: space-between;
            li {
              width: 48%;
              height: auto;
              border-bottom: 1px solid #cbcbcb;
              margin: 0;
              margin-bottom: 10px;
              padding-bottom: 10px;
              img {
                height: auto;
              }
              p {
                font-size: 12px;
                padding: 0;
                margin-top: 0;
                margin-bottom: 5px;
              }
              h3 {
                font-size: 16px;
                height: auto;
                padding: 0;
                font-weight: normal;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
              div {
                padding: 0;
                margin: 0;
              }
              .imgbox {
                height: auto;
              }
            }
          }
        }
        .contentBox3 {
          .yybox {
            width: 100%;
            display: block;
            .item {
              width: auto;
              height: auto;
              margin-bottom: 10px;
              &.item2 {
                height: auto;
              }
            }
          }
        }
        .contentBox2 {
          display: block;
          .l {
            width: auto;
            height: auto;
        }
      }
    }
  }
}
</style>
